import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-061d6b8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-view-wrapper" }
const _hoisted_2 = { class: "profile-view" }
const _hoisted_3 = { class: "order-history" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-history__title title" }, "Покупки", -1))
const _hoisted_5 = { class: "order-history__content" }
const _hoisted_6 = { class: "addressees" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "addressees__title title" }, "Получатель", -1))
const _hoisted_8 = { class: "addressees__content" }
const _hoisted_9 = { class: "addresses" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "addresses__title title" }, "Адреса доставки", -1))
const _hoisted_11 = { class: "addresses__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserInfoPanel = _resolveComponent("UserInfoPanel")!
  const _component_OrderHistoryPanel = _resolveComponent("OrderHistoryPanel")!
  const _component_UserCustomersList = _resolveComponent("UserCustomersList")!
  const _component_DeliveryAddressesList = _resolveComponent("DeliveryAddressesList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.authStore.moBaseUser)
      ? (_openBlock(), _createBlock(_component_UserInfoPanel, {
          key: 0,
          "mo-base-user": _ctx.authStore.moBaseUser
        }, null, 8, ["mo-base-user"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_OrderHistoryPanel)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_UserCustomersList, {
            "selected-id": _ctx.selectedUserCustomerId,
            onWasCreated: _ctx.userCustomerStore.update,
            onWasSelected: _cache[0] || (_cache[0] = (addr) => _ctx.userCustomerStore.setDefault(addr.id))
          }, null, 8, ["selected-id", "onWasCreated"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_DeliveryAddressesList, {
            "selected-id": _ctx.selectedDeliveryAddressId,
            onWasUpdated: _ctx.deliveryAddressesStore.update,
            onWasSelected: _cache[1] || (_cache[1] = (addr) => _ctx.deliveryAddressesStore.setDefault(addr.id))
          }, null, 8, ["selected-id", "onWasUpdated"])
        ])
      ])
    ])
  ]))
}